import React from "react";
import { compareTrancheDetails } from "../../../../utils/helperFunctions";
import FormTriggers from "../../../../layouts/FormTriggers";
import { verifyCheckBoxes } from "../../../../utils/detail";
import { formatAmount } from "../../../../utils/format";
import { OfflinePaymentModes } from "../../../../utils/constant";

const BankandPaymentDetails = ({
  payCount,
  state,
  formFieldState,
  setFormFieldState,
  payment,
  caseDetails,
  stepDetails,
  checkpoints,
  tuComparable,
  user,
  disableMaker,
  disable,
  handleInputChange,
  handleTriggerChange,
  fetchBalAmount,
  ifscMappingFunc,
  compareLedgerWithDisbAmtFunc,
  checkSuperMaker,
  dtsPaymentMax,
  showTrancheChecklist,
}) => {
  const idx = payCount - 1;
  const toggleForeclosureTooltip = () => {
    formFieldState[idx].showForeclosureTooltip =
      !formFieldState[idx].showForeclosureTooltip;
    setFormFieldState([...formFieldState]);
  };
  const trancheCancellationData = state.paymentTrancheDetails.cancellationData[
    idx
  ]
    ? state.paymentTrancheDetails.cancellationData[idx]
    : {};
  const trancheForClosureData = state.paymentTrancheDetails.forClosureData[idx]
    ? state.paymentTrancheDetails.forClosureData[idx]
    : {};

  let disableValues = true;

  const isForeclosure =
    Object.keys(trancheForClosureData).length &&
    trancheForClosureData.release_foreclosure_amount > 0;

  const isCancellation = Object.keys(trancheCancellationData).length > 1;

  if (isForeclosure || isCancellation) {
    disableValues = false;
  }
  const with_held_charges = payment.with_held_charges;
  const payeeIFSC = `payee_ifsc_code_${payCount}`;
  const payee_ifsc_code = payment.payee_ifsc_code
    ? payment.payee_ifsc_code
    : "";
  const checkIFSCCode = checkpoints[payeeIFSC] === "1" ? true : false;
  const uncheckIFSCCode = checkpoints[payeeIFSC] === "0" ? true : false;
  const tuMatchIFSCCode = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeIFSC,
    payee_ifsc_code,
    payment.save_as_draft,
    user.id
  );

  const payeeBankName = `payee_bank_name_${payCount}`;
  const payee_bank_name = payment.payee_bank_name
    ? payment.payee_bank_name
    : "";
  const checkBankName = checkpoints[payeeBankName] === "1" ? true : false;
  const uncheckBankName = checkpoints[payeeBankName] === "0" ? true : false;

  const tuMatchBankName = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeBankName,
    payee_bank_name,
    payment.save_as_draft,
    user.id
  );

  const payeeBranch = `payee_branch_name_${payCount}`;
  const payee_branch_name = payment.payee_branch_name
    ? payment.payee_branch_name
    : "";
  const checkBranchName = checkpoints[payeeBranch] === "1" ? true : false;
  const uncheckBranchName = checkpoints[payeeBranch] === "0" ? true : false;

  const tuMatchBranchName = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeBranch,
    payee_branch_name,
    payment.save_as_draft,
    user.id
  );

  const disburseBalAmount = `disburse_bal_amt_${payCount}`;
  const balAmount = payment.disburse_bal_amt ? payment.disburse_bal_amt : "0";
  const checkDisburseBalAmount =
    checkpoints[disburseBalAmount] === "1" ? true : false;
  const uncheckDisburseBalAmount =
    checkpoints[disburseBalAmount] === "0" ? true : false;

  const spanBalAmount = `span_bal_amt_${payCount}`;

  let net_amount = parseInt(payment.netAmountVal),
    paid_amount = parseInt(payment.paidAmountVal);
  const disburse_payable_amt = `disburse_payable_amt_${payCount}`;
  const disburse_paid_amt = `disburse_paid_amt_${payCount}`;

  const checkDisbursePayableAmount =
    checkpoints[disburse_payable_amt] === "1" ? true : false;
  const uncheckDisbursePayableAmount =
    checkpoints[disburse_payable_amt] === "0" ? true : false;

  const tuMatchDisbursePaid = compareTrancheDetails(
    caseDetails,
    tuComparable,
    disburse_paid_amt,
    paid_amount,
    payment.save_as_draft,
    user.id
  );
  return (
    <>
      {payment.payable_ac_number !== "Direct Payment" &&
      (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
        !disableValues) ? (
        <tr className={`pay-details-hide-${payCount}`}>
          <td className={tuMatchIFSCCode.class}>
            IFSC Code
            <span className="col-red">*</span>
          </td>
          {!disableMaker ? (
            <td>
              <input
                type="text"
                value={payee_ifsc_code?.toUpperCase()}
                id={payeeIFSC}
                name={payeeIFSC}
                disabled={disableValues}
                placeholder="Enter IFSC Code"
                maxLength="11"
                className={`form-control convert-to-uppercase ${
                  payment.payeeIFSCClass ? payment.payeeIFSCClass : ""
                }`}
                readOnly={payment.payeeIfscCodeReadOnly}
                onChange={(e) => handleInputChange(e, idx, "payee_ifsc_code")}
                onBlur={() => ifscMappingFunc(idx)}
              />
              <div
                className="errorTxt"
                id={`error_payee_ifsc_code_${payCount}`}
              >
                {payment.errorpayeeIFSCMsg ? payment.errorpayeeIFSCMsg : ""}
              </div>
            </td>
          ) : (
            <td className={tuMatchIFSCCode.class}>
              {payee_ifsc_code === "" ? "NA" : payee_ifsc_code}
              <input
                type="hidden"
                value={payee_ifsc_code}
                id={payeeIFSC}
                name={payeeIFSC}
                readOnly={payment.payeeIfscCodeReadOnly}
                className={payment.payeeIFSCClass ? payment.payeeIFSCClass : ""}
                onChange={(e) => handleInputChange(e, idx, "payee_ifsc_code")}
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={payeeIFSC}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) || checkIFSCCode
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) || uncheckIFSCCode
              }
              errorClass={
                payment.showPayeeIFscCodeTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      {payment.payable_ac_number !== "Direct Payment" &&
      (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
        !disableValues) ? (
        <tr className={`pay-details-hide-${payCount}`}>
          <td className={tuMatchBankName.class}>
            Bank
            <span className="col-red">*</span>
          </td>
          {!disableMaker ? (
            <td>
              <input
                type="text"
                value={payee_bank_name ? payee_bank_name : ""}
                id={payeeBankName}
                name={payeeBankName}
                disabled={disableValues}
                placeholder="Enter Bank Name"
                className={`form-control ${
                  payment.payeeBankNameClass ? payment.payeeBankNameClass : ""
                }`}
                readOnly={payment.payeeBankNameReadOnly}
                onChange={(e) => handleInputChange(e, idx, "payee_bank_name")}
              />
              <div
                className="errorTxt"
                id={`error_payee_bank_name_${payCount}`}
              >
                {payment.errorpayeeBankNameMsg
                  ? payment.errorpayeeBankNameMsg
                  : ""}
              </div>
            </td>
          ) : (
            <td className={tuMatchBankName.class}>
              {payee_bank_name === "" ? "NA" : payee_bank_name}
              <input
                type="hidden"
                value={payee_bank_name ? payee_bank_name : ""}
                id={payeeBankName}
                name={payeeBankName}
                readOnly={payment.payeeBankNameReadOnly}
                className={
                  payment.payeeBankNameClass ? payment.payeeBankNameClass : ""
                }
                onChange={(e) => handleInputChange(e, idx, "payee_bank_name")}
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={payeeBankName}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) || checkBankName
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) || uncheckBankName
              }
              errorClass={
                payment.showPayeeBankNameTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      {payment.payable_ac_number !== "Direct Payment" ? (
        <tr className={`pay-details-hide-${payCount}`}>
          <td className={tuMatchBranchName.class}>
            Branch
            <span className="col-red">*</span>
          </td>
          {!disableMaker ? (
            <td>
              <input
                type="text"
                value={payee_branch_name ? payee_branch_name : ""}
                id={payeeBranch}
                name={payeeBranch}
                disabled={
                  formFieldState[idx]?.forceEditable ? false : disableValues
                }
                placeholder="Enter Branch Name"
                className={`form-control ${
                  payment.payeeBranchNameClass
                    ? payment.payeeBranchNameClass
                    : ""
                }`}
                readOnly={payment.payeeBranchNameReadOnly}
                onChange={(e) => handleInputChange(e, idx, "payee_branch_name")}
              />
              <div
                className="errorTxt"
                id={`error_payee_branch_name_${payCount}`}
              >
                {payment.errorpayeeBranchNameMsg
                  ? payment.errorpayeeBranchNameMsg
                  : ""}
              </div>
            </td>
          ) : (
            <td className={tuMatchBranchName.class}>
              {payee_branch_name === "" ? "NA" : payee_branch_name}
              <input
                type="hidden"
                value={payee_branch_name ? payee_branch_name : ""}
                id={payeeBranch}
                name={payeeBranch}
                readOnly={payment.payeeBranchNameReadOnly}
                className={
                  payment.payeeBranchNameClass
                    ? payment.payeeBranchNameClass
                    : ""
                }
                onChange={(e) => handleInputChange(e, idx, "payee_branch_name")}
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={payeeBranch}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) || checkBranchName
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) || uncheckBranchName
              }
              errorClass={
                payment.showPayeeBranchNameTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      <tr>
        <td width="20%" className={tuMatchDisbursePaid.class}>
          Payment Disb.
          {checkSuperMaker && dtsPaymentMax === payment.pay_count && (
            <span className="col-red">*</span>
          )}
        </td>
        <td width="20%" className={tuMatchDisbursePaid.class}>
          <input
            type="hidden"
            value={net_amount ? net_amount : "0"}
            name={disburse_payable_amt}
            id={disburse_payable_amt}
            placeholder="Enter Amount"
            className="form-control"
            onChange={(e) => handleInputChange(e, idx, "netAmountVal")}
          />
          {!payment.hideLastPayDiv ? (
            <>
              <div id="lastPayDiv"></div>
              <input
                type="text"
                value={paid_amount || paid_amount === 0 ? paid_amount : ""}
                name={disburse_paid_amt}
                id={disburse_paid_amt}
                placeholder="Enter Amount"
                className={`form-control disb_amt ${
                  payment.disbursePaidAmtClass
                    ? payment.disbursePaidAmtClass
                    : ""
                }`}
                readOnly={payment.disbursePaidAmtReadOnly}
                onChange={(e) => handleInputChange(e, idx, "paidAmountVal")}
                onKeyUp={() =>
                  fetchBalAmount(
                    idx,
                    state.paymentTrancheDetails.trancheNameListData,
                    true,
                    false
                  )
                }
                onBlur={() => compareLedgerWithDisbAmtFunc(idx)}
                disabled={
                  disableValues
                    ? OfflinePaymentModes.includes(payment.payment_mode)
                      ? true
                      : false
                    : false
                }
              />
              <div
                className="errorTxt"
                id={`error_disburse_paid_amt_${payCount}`}
              >
                {payment.errordisbursePaidAmtMsg
                  ? payment.errordisbursePaidAmtMsg
                  : ""}
              </div>
            </>
          ) : (
            <>
              <input
                type="hidden"
                value={paid_amount || paid_amount === 0 ? paid_amount : ""}
                name={disburse_paid_amt}
                id={disburse_paid_amt}
                readOnly={payment.disbursePaidAmtReadOnly}
                onChange={(e) => handleInputChange(e, idx, "paidAmountVal")}
                className={
                  payment.disbursePaidAmtClass
                    ? payment.disbursePaidAmtClass
                    : ""
                }
              />
              <span className="fa fa-inr"></span>
              {formatAmount(paid_amount)}
            </>
          )}
        </td>
        {stepDetails.checklist && showTrancheChecklist ? (
          <FormTriggers
            triggerName={disburse_payable_amt}
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(payment, user.dts_user) ||
              checkDisbursePayableAmount
            }
            showNoButton={
              verifyCheckBoxes(payment, user.dts_user) ||
              uncheckDisbursePayableAmount
            }
            errorClass={
              payment.showDisbursePayableAmtTriggerError ? "has-error" : ""
            }
            triggerValues={checkpoints}
            caseDetails={caseDetails}
            handleTriggerChange={handleTriggerChange}
          />
        ) : (
          ""
        )}
      </tr>
      {(() => {
        if (isCancellation) {
          const recoveredAmount = `recovered_amount_${payCount}`;
          const recovered_amount = !payment.recovered_amount
            ? 0
            : payment.recovered_amount;
          const checkRecoveredAmount =
            checkpoints[recoveredAmount] === "1" ? true : false;
          const uncheckRecoveredAmount =
            checkpoints[recoveredAmount] === "0" ? true : false;

          const moneyReturnedToBank = `money_returned_to_bank_${payCount}`;
          const checkMoneyReturnedToBank =
            checkpoints[moneyReturnedToBank] === "1" ? true : false;
          const uncheckMoneyReturnedToBank =
            checkpoints[moneyReturnedToBank] === "0" ? true : false;

          return (
            <>
              <tr>
                {!disableMaker ? (
                  <>
                    <td width="20%">Recovered Amount to be Released</td>
                    <td width="20%">
                      <input
                        type="text"
                        className="form-control"
                        value={recovered_amount ? recovered_amount : ""}
                        name="recovered_amount"
                        id={recoveredAmount}
                        onChange={(e) =>
                          handleInputChange(e, idx, "recovered_amount")
                        }
                        onKeyUp={() =>
                          fetchBalAmount(
                            idx,
                            state.paymentTrancheDetails.trancheNameListData,
                            true,
                            false
                          )
                        }
                      />
                    </td>
                  </>
                ) : (
                  <>
                    <td width="20%">Recovered Amount to be Released</td>
                    <td width="20%">
                      <span className="fa fa-inr">
                        {formatAmount(parseInt(recovered_amount))}
                      </span>
                    </td>
                  </>
                )}
                {stepDetails.checklist && showTrancheChecklist ? (
                  <FormTriggers
                    triggerName={recoveredAmount}
                    disabled={disable}
                    showYesButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      checkRecoveredAmount
                    }
                    showNoButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      uncheckRecoveredAmount
                    }
                    errorClass={
                      payment.showRecoveredAmountTriggerError ? "has-error" : ""
                    }
                    triggerValues={checkpoints}
                    caseDetails={caseDetails}
                    handleTriggerChange={handleTriggerChange}
                  />
                ) : (
                  ""
                )}
              </tr>
              <tr>
                {!disableMaker ? (
                  <>
                    <td width="20%">Cancellation Charges</td>
                    <td>
                      <span className="fa fa-inr">
                        {formatAmount(parseInt(payment.cancellationChargesVal))}
                      </span>
                      <input
                        type="hidden"
                        value={payment.cancellationChargesVal}
                        name="cancellation_charges"
                        id={`cancellation_charges_${payCount}`}
                        onChange={(e) =>
                          handleInputChange(e, idx, "cancellationChargesVal")
                        }
                      />
                    </td>
                  </>
                ) : (
                  <>
                    <td width="20%">Cancellation Charges</td>
                    <td>
                      <span className="fa fa-inr">
                        {formatAmount(parseInt(payment.cancellationChargesVal))}
                      </span>
                    </td>
                  </>
                )}
              </tr>
              <tr>
                {!disableMaker ? (
                  <>
                    <td width="20%">Money returned to Bank</td>
                    <td width="20%">
                      <span className="fa fa-inr" id={moneyReturnedToBank}>
                        {formatAmount(+payment.money_returned_to_bank)}
                      </span>
                      <input
                        type="hidden"
                        value={
                          payment.money_returned_to_bank
                            ? payment.money_returned_to_bank
                            : ""
                        }
                        name="money_returned_to_bank"
                        id={moneyReturnedToBank}
                        onChange={(e) =>
                          handleInputChange(e, idx, "money_returned_to_bank")
                        }
                      />
                    </td>
                  </>
                ) : (
                  <>
                    <td width="20%">Money returned to Bank</td>
                    <td width="20%">
                      <span className="fa fa-inr">
                        {payment.money_returned_to_bank &&
                        parseInt(payment.money_returned_to_bank)
                          ? formatAmount(
                              parseInt(payment.money_returned_to_bank)
                            )
                          : 0}
                      </span>
                    </td>
                  </>
                )}
                {stepDetails.checklist && showTrancheChecklist ? (
                  <FormTriggers
                    triggerName={moneyReturnedToBank}
                    disabled={disable}
                    showYesButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      checkMoneyReturnedToBank
                    }
                    showNoButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      uncheckMoneyReturnedToBank
                    }
                    errorClass={
                      payment.showMoneyReturnedToBankTriggerError
                        ? "has-error"
                        : ""
                    }
                    triggerValues={checkpoints}
                    caseDetails={caseDetails}
                    handleTriggerChange={handleTriggerChange}
                  />
                ) : (
                  ""
                )}
              </tr>
            </>
          );
        }
      })()}
      {(() => {
        if (payCount === 1 && isForeclosure) {
          const releaseForeclosureAmount = `release_foreclosure_amount_${payCount}`;
          const checkReleaseForeclosureAmount =
            checkpoints[releaseForeclosureAmount] === "1" ? true : false;
          const uncheckReleaseForeclosureAmount =
            checkpoints[releaseForeclosureAmount] === "0" ? true : false;

          const totalForeclosureAmount = `total_foreclosure_amount_${payCount}`;
          const checkTotalForeclosureAmount =
            checkpoints[totalForeclosureAmount] === "1" ? true : false;
          const uncheckTotalForeclosureAmount =
            checkpoints[totalForeclosureAmount] === "0" ? true : false;

          let release_foreclosure_amount = payment.releaseForeclosureAmountVal,
            total_foreclosure_amount = payment.totalForeclosureAmountVal;

          return (
            <>
              <tr>
                <td width="20%">
                  <span
                    className={`${payment.mismatchClass} release-foreclosure-label`}
                  >
                    Extra Loan Foreclosure Amount
                  </span>
                  <button
                    type="foreclosure-tooltip"
                    title="More Details"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleForeclosureTooltip(idx);
                    }}
                    className="ic_info"
                  >
                    <img
                      src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                      alt=""
                    />
                  </button>
                  {payment.showForeclosureTooltip ? (
                    <div className="trache_tooltip_wrapper foreclosure-tooltip">
                      <div className="x_panel">
                        <div className="x_title">
                          <h2>ForeClosure Detail from LoanBox</h2>
                          <div className="clearfix"></div>
                        </div>
                        <div
                          className="x_content"
                          style={{
                            padding: "0px",
                          }}
                        >
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <tbody>
                                <tr className="headings">
                                  <td width="70%" className="column-title">
                                    Total Loan Foreclosure Amount
                                  </td>
                                  <td width="30%">
                                    <span className="fa fa-inr"></span>
                                    {formatAmount(
                                      parseInt(
                                        trancheForClosureData.total_foreclosure_amount
                                      )
                                    )}
                                  </td>
                                </tr>
                                <tr className="headings">
                                  <td width="70%" className="column-title">
                                    Extra Amount to be released
                                  </td>
                                  <td width="30%">
                                    <span className="fa fa-inr"></span>
                                    {formatAmount(
                                      parseInt(
                                        trancheForClosureData.release_foreclosure_amount
                                      )
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </td>
                {!disableMaker ? (
                  <>
                    <td width="20%">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          release_foreclosure_amount
                            ? release_foreclosure_amount
                            : ""
                        }
                        name="release_foreclosure_amount"
                        id={releaseForeclosureAmount}
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            idx,
                            "releaseForeclosureAmountVal"
                          )
                        }
                        onKeyUp={() =>
                          fetchBalAmount(
                            idx,
                            state.paymentTrancheDetails.trancheNameListData,
                            true,
                            false
                          )
                        }
                      />
                    </td>
                  </>
                ) : (
                  <>
                    <td width="20%">
                      <span className="fa fa-inr">
                        {formatAmount(parseInt(release_foreclosure_amount))}
                      </span>
                    </td>
                  </>
                )}
                {stepDetails.checklist && showTrancheChecklist ? (
                  <FormTriggers
                    triggerName={releaseForeclosureAmount}
                    disabled={disable}
                    showYesButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      checkReleaseForeclosureAmount
                    }
                    showNoButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      uncheckReleaseForeclosureAmount
                    }
                    errorClass={
                      payment.showReleaseForeclosureAmountTriggerError
                        ? "has-error"
                        : ""
                    }
                    triggerValues={checkpoints}
                    caseDetails={caseDetails}
                    handleTriggerChange={handleTriggerChange}
                  />
                ) : (
                  ""
                )}
              </tr>
              <tr>
                {!disableMaker ? (
                  <>
                    <td width="20%">Total Loan Foreclosure Amount</td>
                    <td width="20%">
                      <span className="fa fa-inr" id={totalForeclosureAmount}>
                        {formatAmount(parseInt(total_foreclosure_amount))}
                      </span>
                      <input
                        type="hidden"
                        value={
                          total_foreclosure_amount
                            ? total_foreclosure_amount
                            : ""
                        }
                        name="total_foreclosure_amount"
                        id={totalForeclosureAmount}
                        onChange={(e) =>
                          handleInputChange(e, idx, "totalForeclosureAmountVal")
                        }
                      />
                    </td>
                  </>
                ) : (
                  <>
                    <td width="20%">Total Loan Foreclosure Amount</td>
                    <td width="20%">
                      <span className="fa fa-inr">
                        {formatAmount(parseInt(total_foreclosure_amount))}
                      </span>
                    </td>
                  </>
                )}
                {stepDetails.checklist && showTrancheChecklist ? (
                  <FormTriggers
                    triggerName={totalForeclosureAmount}
                    disabled={disable}
                    showYesButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      checkTotalForeclosureAmount
                    }
                    showNoButton={
                      verifyCheckBoxes(payment, user.dts_user) ||
                      uncheckTotalForeclosureAmount
                    }
                    errorClass={
                      payment.showTotalForeclosureAmountTriggerError
                        ? "has-error"
                        : ""
                    }
                    triggerValues={checkpoints}
                    caseDetails={caseDetails}
                    handleTriggerChange={handleTriggerChange}
                  />
                ) : (
                  ""
                )}
              </tr>
            </>
          );
        }
      })()}
      <tr>
        <td>Balance </td>
        <td>
          <input
            type="hidden"
            value={with_held_charges ? with_held_charges : ""}
            name={`with_held_amount_${payCount}`}
            id={`with_held_amount_${payCount}`}
            onChange={(e) => handleInputChange(e, idx, "with_held_charges")}
          />
          <input
            type="hidden"
            id={disburseBalAmount}
            name={disburseBalAmount}
            value={balAmount ? balAmount : ""}
            onChange={(e) => handleInputChange(e, idx, "disburse_bal_amt")}
          />
          <span className="fa fa-inr" id={spanBalAmount}>
            {formatAmount(parseInt(balAmount))}
          </span>
        </td>
        {stepDetails.checklist && showTrancheChecklist ? (
          <FormTriggers
            triggerName={disburseBalAmount}
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(payment, user.dts_user) || checkDisburseBalAmount
            }
            showNoButton={
              verifyCheckBoxes(payment, user.dts_user) ||
              uncheckDisburseBalAmount
            }
            errorClass={
              payment.showDisburseBalAmtTriggerError ? "has-error" : ""
            }
            triggerValues={checkpoints}
            caseDetails={caseDetails}
            handleTriggerChange={handleTriggerChange}
          />
        ) : (
          ""
        )}
      </tr>
    </>
  );
};

export default BankandPaymentDetails;
